import React from 'react';

import './table-wrapper.scss';

const TableWrapper: React.FC = ({ children }) => (
  <div className="table-wrapper">{children}</div>
);

export default TableWrapper;
